// extracted by mini-css-extract-plugin
export var arrow = "Z_dh";
export var check = "Z_dj";
export var details = "Z_db";
export var icon = "Z_n";
export var info = "Z_dc";
export var list = "Z_dd";
export var more = "Z_dg";
export var remove = "Z_dk";
export var ribbon = "Z_df";
export var row = "Z_c8";
export var type = "Z_c9";